import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";
import { useEffect, useState } from "react";
import { getChartDataLicense, getDashboardLicenseReport } from "../../actions/charts/chart";
import { toast } from "react-toastify";
import ChartTwo from "../../components/Charts/ChartTwo";
import ChartLine from "../../components/Charts/ChartLine";
import Footer from "../authentication/components/Footer";
import { ShimmerPostList } from "react-shimmer-effects";
import CustomLoader from "../../components/Loading/TopBarLoader";
import { Button } from "@heroui/button";
import { FaCalendar } from "react-icons/fa";
import { Chip, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, useDisclosure } from "@heroui/react";
import CustomDatePicker from "../../components/CustomDatePicker";
import { convertToJalali } from "../../extension/dateConvert";

function DashboardLicense() {
  const [pending, setLoading] = useState(true);
  const { sales, tasks } = reportsLineChartData;
  const [charts, setChartData] = useState([]);
  const [chartsRecargo, setChartRecargoData] = useState([]);
  const [chartWeight, setChartWeight] = useState([]);
  const [chartReWeight, setChartReWeight] = useState([]);
  const [chartEquipment, setChartEquipment] = useState([]);
  const [chartReEquipment, setChartReEquipment] = useState([]);
  const [chartWeightEquipment, setChartWeightEquipment] = useState([]);
  const [chartReWeightEquipment, setChartReWeightEquipment] = useState([]);
  const [chartAmount, setChartAmount] = useState([]);
  const [chartJens, setChartJens] = useState([]);
  const [chartUserCargo, setChartUserCargo] = useState([]);
  const [chartFunctionCargo, setChartFunctionCargo] = useState([]);
  const [chartFunctionEquipment, setChartFunctionEquipment] = useState([]);
  const [chartStopCargo, setChartStopCargo] = useState([]);
  const [chartStopEquipment, setChartStopEquipment] = useState([]);
  const [chartUserCountLicenseCargo, setChartUserCountLicenseCargo] = useState([]);
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  // تعداد گزارشات
  const [countAllReport, setCountAllReport] = useState({
    count_all: "--", count_charge: "--",
    count_recharge: "--", count_users: "--",
  });
  async function getChart(from,to) {
    try {
      setLoading(true);
      const data = await getChartDataLicense(from,to);
      setLoading(false);
      setChartData(data.message.Cargo);
      setChartWeight(data.message.Weight);
      setChartEquipment(data.message.Equipment);
      setChartWeightEquipment(data.message.WeightEquipment);
      setChartJens(data.message.Jens);
      setChartFunctionCargo(data.message.FunctionCargos);
      setChartFunctionEquipment(data.message.FunctionEquipmentCargos);
      setChartStopCargo(data.message.StopCargos);
      setChartStopEquipment(data.message.StopEquipmentCargos);
      setChartUserCountLicenseCargo(data.message.UserCountLicenseCargo);
    } catch (e) {
      toast.error("خطا در اتصال به سرور!");
    }
  }
  async function fetchDashboardReport(from,to) {
    try {
      const data = await getDashboardLicenseReport(from,to);
      setCountAllReport({
        count_all: data.message.all_cargos, count_charge: data.message.charge,
        count_recharge: data.message.Recharge, count_users: data.message.userCount,
      });
    } catch (error) {
      toast.error("خطا در دریافت گزارشات!");
    }
  }
  useEffect(() => {
    getChart();
    fetchDashboardReport();
  }, []);

  return (
    <>
      <CustomLoader isLoading={pending} />
      <DashboardLayout>
        {pending ? (
          <ShimmerPostList postStyle="STYLE_SIX" col={2} row={3} gap={30} />
        ) : (
          <MDBox py={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="dark"
                    icon="factory"
                    title="مجموع بارگیری و تخلیه بار"
                    count={countAllReport.count_all}
                    percentage={{
                      color: "success",
                      amount: "+55%",
                      label: "than lask week",
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    icon="person_add"
                    title="تعداد کاربران"
                    count={countAllReport.count_users}
                    percentage={{
                      color: "success",
                      amount: "+3%",
                      label: "than last month",
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="success"
                    icon="local_shipping"
                    title="تخلیه بار ها"
                    count={countAllReport.count_recharge}
                    percentage={{
                      color: "success",
                      amount: "+1%",
                      label: "than yesterday",
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="primary"
                    icon="leaderboard"
                    title="بارگیری ها"
                    count={countAllReport.count_charge}
                    percentage={{
                      color: "success",
                      amount: "",
                      label: "Just updated",
                    }}
                  />
                </MDBox>
              </Grid>
            </Grid>
            <div className={"flex justify-between"}>
              <Button color="primary" onPress={onOpen} className={"text-white"} endContent={<FaCalendar />}>
                اعمال فیلتر
              </Button>
              {(startDate && endDate) && (
                <div className="gap-2 space-x-3">
                  <Chip color="default" className="mx-2">
                    تاریخ شروع : {convertToJalali(startDate)}
                  </Chip>
                  <Chip color="default" className="mx-2">
                    تاریخ پایان : {convertToJalali(endDate)}
                  </Chip>
                </div>
              )}


            </div>
            <MDBox mt={4.5}>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={4}>
                  <ReportsBarChart
                    color="light"
                    date="20 دستگاه با بیشترین عملکرد ( براساس تعداد )"
                    chart={<ChartTwo data={charts} sub_title="تعداد"
                                     title="20 دستگاه با بیشترین عملکرد ( براساس تعداد )" />}
                    title={""} />
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <ReportsBarChart
                    title={""}
                    color="light"
                    date="20 دستگاه با بیشترین عملکرد ( براساس تناژ )"
                    chart={<ChartTwo data={chartWeight} sub_title="تناژ"
                                     title="20 دستگاه با بیشترین عملکرد ( براساس تناژ )" />}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <ReportsBarChart
                    title={""}
                    color="light"
                    date="20 تجهیز با بیشترین عملکرد ( براساس تعداد )"
                    chart={<ChartTwo data={chartEquipment} sub_title="تعداد"
                                     title="20 تجهیز با بیشترین عملکرد ( براساس تعداد )" />}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3} mt={2}>
                <Grid item xs={12} md={6} lg={4}>
                  <ReportsBarChart
                    color="light"
                    title={""}
                    date="20 تجهیز با بیشترین عملکرد ( براساس تناژ )"
                    chart={<ChartLine data={chartWeightEquipment} sub_title="تناژ"
                                      title="20 تجهیز با بیشترین عملکرد ( براساس تناژ )" />}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <ReportsBarChart
                    color="light"
                    title={""}
                    date="20 کالا با بیشترین تناژ ( جابجائی )"
                    chart={<ChartLine data={chartJens} sub_title="تناژ" title="20 کالا با بیشترین تناژ ( جابجائی )" />}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <ReportsBarChart
                    color="light"
                    title={""}
                    date="20 دستگاه با بیشترین کارکرد"
                    chart={<ChartLine data={chartFunctionCargo} sub_title="ساعت"
                                      title="20 دستگاه با بیشترین کارکرد" />}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3} mt={2}>
                <Grid item xs={12} md={6} lg={4}>
                  <ReportsBarChart
                    color="light"
                    title={""}
                    date="20 تجهیز با بیشترین کارکرد"
                    chart={<ChartTwo data={chartFunctionEquipment} sub_title="ساعت"
                                     title="20 تجهیز با بیشترین کارکرد" />}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <ReportsBarChart
                    color="light"
                    title={""}
                    date="20 دستگاه با بیشترین توقف"
                    chart={<ChartTwo data={chartStopCargo} sub_title="ساعت" title="20 دستگاه با بیشترین توقف" />}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <ReportsBarChart
                    title={""}
                    color="light"
                    date="20 تجهیز با بیشترین توقف"
                    chart={<ChartTwo data={chartStopEquipment} sub_title="ساعت" title="20 تجهیز با بیشترین توقف" />}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3} mt={2}>
                <Grid item xs={12} md={6} lg={4}>
                  <ReportsBarChart
                    color="light"
                    title={""}
                    date="20 مسئول عملیات با بیشترین ثبت"
                    chart={<ChartTwo data={chartUserCountLicenseCargo} sub_title="تعداد"
                                     title="20 مسئول عملیات با بیشترین ثبت" />}
                  />
                </Grid>
              </Grid></MDBox> </MDBox>

        )}
        <br />
        <Footer dark />
        <Modal isOpen={isOpen} onOpenChange={onOpenChange} isDismissable={false}
               shouldCloseOnOverlayClick={false}>
          <ModalContent>
            {(onClose) => (
              <>
                <ModalHeader className="flex flex-col gap-1">فیلتر بازه تاریخ</ModalHeader>
                <ModalBody>

                  <CustomDatePicker placeholder={"از تاریخ"} name="start_date" defaultValue={startDate}
                                    onChange={(v) => setStartDate(v)} />
                  <CustomDatePicker placeholder={"تا تاریخ"} name="end_date"
                                    defaultValue={endDate}
                                    onChange={(v) => setEndDate(v)} />
                </ModalBody>
                <ModalFooter>
                  <Button color="danger" variant="light" onPress={onClose}>
                    بستن
                  </Button>
                  <Button color="primary" onPress={()=>{
                    if(startDate && endDate) {
                      const from = new Date(startDate).toISOString().split("T")[0];
                      const to = new Date(endDate).toISOString().split("T")[0];
                      getChart(from, to);
                      fetchDashboardReport(from,to);
                      onClose();
                    }else {
                      toast.warning("لطفا بازه درستی انتخاب کنید")
                    }
                  }}>
                    اعمال فیلتر
                  </Button>
                </ModalFooter>
              </>
            )}
          </ModalContent>
        </Modal>
      </DashboardLayout>
    </>
  );
}

export default DashboardLicense;
